export const SELECTORS = {
  CARD: 'js-product-card-v3',
  WRAPPER: 'js-product-card-v3-wrapper',
  TEMPLATE: 'js-product-card-v3-template',
  CHECKBOX: 'js-product-card-v3-checkbox-toggle',
  PRODUCT_SWITCHER: 'js-product-card-v3-product-switcher',
  VARIANT_SWITCHER: 'js-product-card-v3-variant-switcher'
};
